import { Injectable } from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomPingInterceptor implements HttpInterceptor {

  constructor() { }

  // Handle PingFederated header Variables
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if ( httpRequest.url.startsWith('http://localhost:8080/api-bpp')) {
      const rawUserInfoString = sessionStorage.getItem('authorization.service.user_info');
      if (rawUserInfoString) {
        const userInfoObject = JSON.parse(rawUserInfoString);
        if (userInfoObject && userInfoObject.uid) {
          httpRequest = httpRequest.clone({
            setHeaders: {'x-slat-02' : userInfoObject.uid}
          });
        }
      }
    }
    return next.handle(httpRequest);
  }
}
